import { Box, Button, Typography } from "@mui/material";
import { Thread } from "@store/threads.store";
import { subDays } from "date-fns";
import { groupThreadsForDisplay } from "../thread-helpers";
import {
  ThreadsContainer,
  ThreadsList,
  ThreadsGroup,
  BlurBlockedOverlay,
  BlockedWarningContainer,
} from "./styles";
import { ThreadItem } from "./ThreadItem";
import { SubscriptionStatus } from "@features/Subscription/subscription.types";
import { Link } from "react-router-dom";
import { SidekickChatAvatarIcon } from "@assets/icons/SidekickChatAvatarIcon";

type Props = {
  userSubscriptionStatus: SubscriptionStatus | null;
};

export const BlockedThreads = (props: Props) => {
  const { userSubscriptionStatus } = props;
  const threads: Thread[] = [
    {
      id: "1",
      title: "Tips for Homebuyers",
      createdAt: subDays(new Date(), 10),
      updatedAt: subDays(new Date(), 10),
      metadata: null,
      pinned: false,
    },
    {
      id: "2",
      title: "Understanding Market Trends",
      createdAt: subDays(new Date(), 10),
      updatedAt: subDays(new Date(), 10),
      metadata: null,
      pinned: false,
    },
    {
      id: "3",
      title: "Guide to Rental Properties",
      createdAt: subDays(new Date(), 10),
      updatedAt: subDays(new Date(), 10),
      metadata: null,
      pinned: false,
    },
    {
      id: "4",
      title: "Best Cities for Investing",
      createdAt: subDays(new Date(), 3),
      updatedAt: subDays(new Date(), 3),
      metadata: null,
      pinned: false,
    },
    {
      id: "5",
      title: "How to Price a Property",
      createdAt: subDays(new Date(), 3),
      updatedAt: subDays(new Date(), 3),
      metadata: null,
      pinned: false,
    },
    {
      id: "6",
      title: "Staging Tips for Sellers",
      createdAt: subDays(new Date(), 3),
      updatedAt: subDays(new Date(), 3),
      metadata: null,
      pinned: false,
    },
    {
      id: "7",
      title: "How to Price a Property",
      createdAt: subDays(new Date(), 3),
      updatedAt: subDays(new Date(), 3),
      metadata: null,
      pinned: false,
    },
    {
      id: "8",
      title: "Guide to Rental Properties",
      createdAt: subDays(new Date(), 3),
      updatedAt: subDays(new Date(), 3),
      metadata: null,
      pinned: false,
    },
  ];

  const groupedThreads = groupThreadsForDisplay(threads);

  const renderThread = (thread: Thread) => {
    return (
      <ThreadItem
        key={thread.id}
        thread={thread}
        handleClickThread={() => {}}
        handlePinClick={() => {}}
        handleUnpinClick={() => {}}
        onRenameThread={() => {}}
        handleDeleteClick={async () => {}}
        currentThread={undefined}
        isFirstThread={false}
      />
    );
  };

  return (
    <ThreadsContainer aria-disabled={true}>
      <BlurBlockedOverlay />
      <BlockedWarningContainer>
        <SidekickChatAvatarIcon />
        <Typography variant="h6" mt={1} mb={2}>
          Unlock Sidekick!
        </Typography>
        {userSubscriptionStatus === "errored" && (
          <Typography>
            There is an problem with your subscription, please contact support.
          </Typography>
        )}
        {userSubscriptionStatus === "suspended" && (
          <Box>
            <Typography mb={3}>
              Your Sidekick subscription is suspended. Access your subscription
              page for more details.
            </Typography>
            <Link to="/account/subscription">
              <Button size="small">View Subscription</Button>
            </Link>
          </Box>
        )}
        {userSubscriptionStatus === "past-due" && (
          <Box>
            <Typography mb={3}>
              To continue using Sidekick and preserve your chat history, update
              your billing information and you’ll be back in no time!
            </Typography>
            <Link to="/account/subscription">
              <Button size="small">Update now</Button>
            </Link>
          </Box>
        )}
      </BlockedWarningContainer>
      <ThreadsList>
        {groupedThreads.today.length > 0 && (
          <ThreadsGroup>
            <Typography variant="h6">Today</Typography>
            {groupedThreads.today.map(renderThread)}
          </ThreadsGroup>
        )}
        {groupedThreads.last7Days.length > 0 && (
          <ThreadsGroup>
            <Typography variant="h6">Previous 7 days</Typography>
            {groupedThreads.last7Days.map(renderThread)}
          </ThreadsGroup>
        )}
        {groupedThreads.last30Days.length > 0 && (
          <ThreadsGroup>
            <Typography variant="h6">Previous 30 days</Typography>
            {groupedThreads.last30Days.map(renderThread)}
          </ThreadsGroup>
        )}
      </ThreadsList>
    </ThreadsContainer>
  );
};
